import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=a4833e80&scoped=true&"
import script from "./about-us.ts?vue&type=script&lang=ts&"
export * from "./about-us.ts?vue&type=script&lang=ts&"
import style0 from "@/assets/styles/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./about-us.scss?vue&type=style&index=1&id=a4833e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4833e80",
  null
  
)

export default component.exports